module.exports = __webpack_public_path__ + "img/vue-logo.96e5850d.png";